import { render, staticRenderFns } from "./CompanyDashboardUpdate.vue?vue&type=template&id=210dfbf4&scoped=true&"
import script from "../../services/company/company-dashboard-update.js?vue&type=script&lang=js&"
export * from "../../services/company/company-dashboard-update.js?vue&type=script&lang=js&"
import style0 from "@/assets/css/form.css?vue&type=style&index=0&id=210dfbf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210dfbf4",
  null
  
)

export default component.exports